import Reflux from 'reflux';

export default  Reflux.createActions([
  'updatePriceTypeQty',
  'updateActiveCategory'
]);



// WEBPACK FOOTER //
// ./frontend/react/actions/edpfilters.js